import { ORDER } from "../Actions/Utilites";

const INITIAL_STATE = {


    //   Get ALl ORDER
    getAllOrderLoading: false,
    getAllOrderSuccess: false,
    getAllOrderFailure: false,
    getAllOrderError: null,
    getAllOrder: [],

    //   Get ORDER
    getOrderLoading: false,
    getOrderSuccess: false,
    getOrderFailure: false,
    getOrderError: null,
    getOrder: null,

    //   Update ORDER
    updateOrderLoading: false,
    updateOrderSuccess: false,
    updateOrderFailure: false,
    updateOrderError: null,
    updateOrder: [],

};

export const OrderReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {

        //   Get All ORDER
        case ORDER.GET_ALL_ORDER_REQUEST:
            return {
                ...state,
                getAllOrderLoading: true,
                getAllOrderSuccess: false,
                getAllOrderFailure: false,
                getAllOrderError: null,
            };
        case ORDER.GET_ALL_ORDER_SUCCESS:
            return {
                ...state,
                getAllOrderLoading: false,
                getAllOrderSuccess: true,
                getAllOrderFailure: false,
                addAllOrderError: null,
                getAllOrder: action.payload.result,
            };
        case ORDER.GET_ALL_ORDER_FAILURE:
            return {
                ...state,
                getAllOrderLoading: false,
                getAllOrderSuccess: false,
                getAllOrderFailure: true,
                getAllOrderError: action.payload,
            };

        // Get Location
        case ORDER.GET_ORDER_REQUEST:
            return {
                ...state,
                getOrderLoading: true,
                getOrderSuccess: false,
                getOrderFailure: false,
                getOrderError: null,
            };
        case ORDER.GET_ORDER_SUCCESS:
            return {
                ...state,
                getOrderLoading: false,
                getOrderSuccess: true,
                getOrderFailure: false,
                addLocationError: null,
                getOrder: action.payload.result,
            };
        case ORDER.GET_ORDER_FAILURE:
            return {
                ...state,
                getOrderLoading: false,
                getOrderSuccess: false,
                getOrderFailure: true,
                getOrderError: action.payload,
            };

        // Update Note
        case ORDER.UPDATE_ORDER_REQUEST:
            return {
                ...state,
                updateOrderLoading: true,
                updateOrderSuccess: false,
                updateOrderFailure: false,
                updateOrderError: null,
            };
        case ORDER.UPDATE_ORDER_SUCCESS:
            return {
                ...state,
                updateOrderLoading: false,
                updateOrderSuccess: true,
                updateOrderFailure: false,
                updateOrderError: null,
                updateOrder: action.payload,
            };
        case ORDER.UPDATE_ORDER_FAILURE:
            return {
                ...state,
                updateOrderLoading: false,
                updateOrderSuccess: false,
                updateOrderFailure: true,
                updateOrderError: action.payload,
            };

        default:
            return state;
    }
};
